import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedDownloadTranscriptButton } from "@air/analytics/src/events/useTrackClickedDownloadTranscriptButton";
import { useTrackDownloadedTranscript } from "@air/analytics/src/events/useTrackDownloadedTranscript";
import { Download } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { memo, useMemo } from "react";
import { centralizedClipIdSelector, centralizedClipSRTUrlSelector, centralizedClipVTTUrlSelector } from "~/store/centralizedClip/selectors";
import { DownloadFile } from "~/utils/DownloadFile";
import { useAirSelector } from "~/utils/ReduxUtils";
export const DownloadTranscriptButton = /*#__PURE__*/ memo(()=>{
    const clipId = useAirSelector(centralizedClipIdSelector);
    const clipVTTUrl = useAirSelector(centralizedClipVTTUrlSelector);
    const clipSRTUrl = useAirSelector(centralizedClipSRTUrlSelector);
    const { trackClickedDownloadTranscriptButton } = useTrackClickedDownloadTranscriptButton();
    const { trackDownloadedTranscript } = useTrackDownloadedTranscript();
    const options = useMemo(()=>{
        const options = [];
        if (clipSRTUrl) {
            options.push({
                id: "download-srt",
                label: "Download .srt",
                type: "item",
                onSelect: ()=>{
                    trackDownloadedTranscript({
                        clip_id: clipId,
                        file_type: "srt"
                    });
                    DownloadFile(clipSRTUrl);
                }
            });
        }
        if (clipVTTUrl) {
            options.push({
                id: "download-vtt",
                label: "Download .vtt",
                type: "item",
                onSelect: ()=>{
                    trackDownloadedTranscript({
                        clip_id: clipId,
                        file_type: "vtt"
                    });
                    DownloadFile(clipVTTUrl);
                }
            });
        }
        return options;
    }, [
        clipId,
        clipSRTUrl,
        clipVTTUrl,
        trackDownloadedTranscript
    ]);
    if (!options.length) {
        return null;
    }
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        trigger: /*#__PURE__*/ _jsx(Button, {
            className: "w-full justify-start",
            prefix: /*#__PURE__*/ _jsx(Download, {
                className: "size-4"
            }),
            appearance: "ghost",
            color: "grey",
            size: "medium",
            onClick: ()=>{
                trackClickedDownloadTranscriptButton({
                    clip_id: clipId
                });
            },
            children: "Download transcript"
        }),
        children: renderDropdownItems({
            options
        })
    });
});
DownloadTranscriptButton.displayName = "DownloadTranscriptButton";
